import { PlacesAutocomplete } from "@components/common/PlaceInput";
import { Place, ScoredPlace } from "@gen/place/v1/place_pb";
import { Spinner } from "@thetreep/ui";

export interface SearchNearPanelProps {
  places?: ScoredPlace[];
  onChange: (p: Place) => void;
}

export function SearchNearPanel({ places, onChange }: SearchNearPanelProps) {
  if (!places) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="w-full self-start md:w-auto md:mt-[51px]">
      <PlacesAutocomplete
        className="md:border md:rounded-md md:border-cnam-light-300 md:max-h-[348px]"
        places={places}
        preserveOrder
        onChange={onChange}
      />
    </div>
  );
}
